var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProviderGitlab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M24 43L16 20 32 20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff7043",
    d: "M24 43L42 20 32 20z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M37 5L42 20 32 20z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa726",
    d: "M24 43L42 20 45 28z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff7043",
    d: "M24 43L6 20 16 20z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M11 5L6 20 16 20z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa726",
    d: "M24 43L6 20 3 28z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderGitlab);
export default __webpack_public_path__ + "static/media/provider-gitlab.svg";
export { ForwardRef as ReactComponent };